import React, { Component } from 'react';

import play from '../../img/button_appstore_android.svg';
import apple from '../../img/button_appstore_apple.svg';
import windows from '../../img/button_appstore_windows.svg';
import amazon from '../../img/amazon.png';
import escolha from '../../img/escolhaappstore.svg';
import huawei from '../../img/huawei.png';


export default () => {
    return (


        <ul className="lista lista-lojas clearfix">


            <li>
                <a href="http://www.escolhatecnologia.com.br/appstore" target="_blank" ><img src={escolha} /></a>
            </li>
            <li>
                <a href="https://play.google.com/store/apps/dev?id=5978392300521042263" target="_blank" ><img src={play} /></a>
            </li>
            <li>
                <a href="https://itunes.apple.com/br/developer/escolha-tecnologia-ltda-me/id962923724" target="_blank" ><img src={apple} /></a>
            </li>
            <li>
                <a href="https://www.microsoft.com/pt-br/store/p/voz-da-mulher-do-tradutor/9nblgggxwrss?rtc=1" target="_blank" ><img src={windows} /></a>
            </li>
            <li>
                <a href="https://www.amazon.com.br/s?ie=UTF8&field-brandtextbin=Escolha%20Tecnologia&index=mobile-apps&search-type=ss" target="_blank" ><img src={amazon} /></a>
            </li>

            <li>
                <a href="https://appgallery.huawei.com/#/app/C101692775" target="_blank" ><img src={huawei} /></a>
            </li>
        </ul>


    );
}



// WEBPACK FOOTER //
// ./src/js/components/stores.js